import styled from 'styled-components';

export const Section = styled.div`
  width: 100%;
  padding: 128px 0;
  background: #fafafa;

  @media (max-width: 900px) {
    padding-top: 32px;
    padding-bottom: 70px;
  }
`;

export const Container = styled.div`
  width: 100%;
  padding-right: 32px;
  padding-left: 32px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 576px) {
    width: 540px;
  }

  @media (min-width: 768px) {
    width: 720px;
  }

  @media (min-width: 992px) {
    width: 960px;
  }

  @media (min-width: 1200px) {
    width: 1140px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 900px) {
    flex-direction: column;
    justify-center: space-between;
    gap: 56px;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: 0;
  color: #004f92;

  @media (max-width: 900px) {
    font-size: 32px;
    line-height: 40px;
    max-width: 189px;
  }
`;

export const Card = styled.div<{ width?: number }>`
  display: flex;
  align-items: center;
  gap: 28px;
  max-width: ${({ width }) => (width ? width : 420)}px;

  img {
    width: 48px;
    height: 48px;
  }

  p {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0;
    color: #898b8e;
  }

  @media (max-width: 900px) {
    max-width: 100%;

    img {
      width: 40px;
      height: 40px;
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 326px;

  padding-top: 8px;

  @media (max-width: 900px) {
    max-width: 100%;
  }
`;

export const ImageSection = styled.img`
  max-width: 512px;
  max-height: 512px;

  @media (max-width: 900px) {
    padding-right: 32px;

    max-width: 304px;
    max-height: 304px;
  }
`;
